module.exports = __webpack_public_path__ + "img/model_5.35aaa343.jpg";